import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
    client: null,
    clients: [],
    clientApps: [],
    clientName: null,
    singleClient: null,
    openClientModal: false,
    openMyAccountModal: false,
    openAppChangeModal: false,
    accessProfileName: ''
  },

  mutations: {
    CLIENT_SELECTED (state, data) {
      state.client = data.client
      state.clientName = data.clientName
      state.singleClient = data.singleClient
      state.selectedMenuItem = null
    },
    OPEN_CHANGE_APP_MODAL (state) {
      state.openAppChangeModal = !state.openAppChangeModal
    },
    OPEN_CLIENT_MODAL (state) {
      state.openClientModal = !state.openClientModal
    },
    OPEN_MYACCOUNT_MODAL (state) {
      state.openMyAccountModal = !state.openMyAccountModal
    },
    SET_CLIENTS (state, clients) {
      state.clients = clients
    },
    ACCESS_PROFILE_SELECTED (state, accessProfileName) {
      state.accessProfileName = accessProfileName
    },
    ACCESS_PROFILE_ID_SELECTED (state, accessProfileId) {
      state.accessProfileId = accessProfileId
    },
    IS_LOGIN_EMULADO (state, isEmulated) {
      state.isEmulated = isEmulated
    },
    SET_CLIENT_APPS (state, apps) {
      state.clientApps = []
      apps.filter(function (element) {
        state.clientApps.push(element['id'])
      })
    }
  },

  actions: {
    getClients: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios.get('/client/').then(response => {
          commit('SET_CLIENTS', response.data)
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    setClient: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/client/', { clientId: data.client }).then(response => {
          commit('CLIENT_SELECTED', data)

          if (response.data.perfilAcesso && response.data.perfilAcesso.nome) {
            commit('ACCESS_PROFILE_ID_SELECTED', response.data.perfilAcesso.id)
            commit('ACCESS_PROFILE_SELECTED', response.data.perfilAcesso.nome)
          }

          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    openClientModal: ({ commit }) => {
      return commit('OPEN_CLIENT_MODAL')
    },

    openMyAccountModal: ({ commit }) => {
      return commit('OPEN_MYACCOUNT_MODAL')
    },

    openAppChangeModal: ({ commit }) => {
      return commit('OPEN_CHANGE_APP_MODAL')
    },

    setClientEmulatedLogin: ({ commit }, data) => {
      commit('CLIENT_SELECTED', data)
      commit('IS_LOGIN_EMULADO', true)
    },

    setAplicacoes: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        commit('SET_CLIENT_APPS', data)
        resolve()
      })
    },

    getAplicacoes: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios.get('/client/aplicacoes').then(response => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    trocaAplicacao: ({ commit }, app) => {
      return new Promise((resolve, reject) => {
        axios.post('/user/login/trocaAplicacao', app).then(response => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    setPerfilAcesso: ({ commit }, perfilAcesso) => {
      return new Promise((resolve, reject) => {
        commit('ACCESS_PROFILE_ID_SELECTED', perfilAcesso.id)
        commit('ACCESS_PROFILE_SELECTED', perfilAcesso.nome)
        resolve()
      })
    }
  },

  getters: {
    client: state => state.client,
    clients: state => state.clients,
    clientName: state => state.clientName,
    singleClient: state => state.singleClient,
    openClientModal: state => state.openClientModal,
    openMyAccountModal: state => state.openMyAccountModal,
    accessProfileName: state => state.accessProfileName,
    accessProfileId: state => state.accessProfileId,
    openAppChangeModal: state => state.openAppChangeModal,
    clientApps: state => state.clientApps,
    isClientEmulatedLogin: state => state.isEmulated
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/client.js